import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

interface DonutsProps {
  id: string;
  data: object[];
}

const Donut: React.FC<DonutsProps> = ({ id, data }) => {
  // const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(id, am4charts.PieChart);

    x.hiddenState.properties.opacity = 0;
    x.background.visible = false;

    // Add data
    x.data = data;

    // Add and configure Series
    var pieSeries = x.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    //pieSeries.dataFields.category = "country";

    // Let's cut a hole in our Pie chart the size of 40% the radius
    x.innerRadius = am4core.percent(30);

    //Change chart radius
    x.radius = am4core.percent(50);

    // Set up fills
    pieSeries.slices.template.fillOpacity = 1;
    //Set slices color
    pieSeries.slices.template.propertyFields.fill = "color";

    //Disable labels  guide line
    pieSeries.ticks.template.disabled = true;

    //Disable tooltip
    pieSeries.slices.template.tooltipText = "";

    //Align labels to slices
    pieSeries.alignLabels = false;

    //Change labels text
    pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";

    //Change label color
    pieSeries.labels.template.fill = am4core.color("#00162b");

    //Change label size
    pieSeries.labels.template.fontSize = 16;

    /*var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.5;*/

    /*--------------------------------------------------------------------------------------*/
    //chart.current = x;

    return () => {
      x.dispose();
    };
  }, []);

  return <div className="chart" id={id}></div>;
};

export default Donut;
